import sum from 'ml-array-sum';

/**
 * Computes the mean of the given values
 * @param {Array<number>} input
 * @return {number}
 */

function mean(input) {
  return sum(input) / input.length;
}

export default mean;
